(() => {
  'use strict';
  function isHome() { return Boolean(document.getElementById('estate-scene')); }
  function cleanLegacyFragment() {
    if (location.hash.toLowerCase() === '#top') {
      try { history.replaceState(history.state, '', location.pathname + location.search); }
      catch (_) { /* URL cleanup is optional in restricted environments. */ }
    }
  }
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[data-estate-scroll-top]');
    if (!anchor || !isHome() || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    cleanLegacyFragment();
    window.scrollTo({top:0,left:0,behavior:'instant'});
  });
  cleanLegacyFragment();
})();
